import { Component, OnInit, Input, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { NewEntryModel } from '../../models/new-entry.model';
import { NewEntryService } from '../../services/new-entry.service';
import * as _ from 'lodash';


@Component({
  selector: 'app-record-detail',
  templateUrl: './record-detail.component.html',
  styleUrls: ['./record-detail.component.scss']
})
export class RecordDetailComponent implements OnInit {

  @Input('gridApi') gridApi;
  @Input() otherSideInfo;
  @Input('newEntry') newEntry:NewEntryModel;

  constructor(
    private newEntryService:NewEntryService,
    private cd:ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
  }


  saveEntryText(newEntryText) {

    Promise.resolve()
      .then(() => this.newEntryService.patch(this.newEntry._id, {
        entryText: newEntryText,
      }))
      .then(newEntry => {
        this.newEntry = newEntry;
        this.gridApi.updateRowData({update: [this.newEntry]});

        this.refreshOtherSideSelectedRow(this.newEntry);
      });

  }

  refreshOtherSideSelectedRow(newEntry) {
    this.otherSideInfo.gridApi.updateRowData({update: [newEntry]});

    const otherSideSelectedRows = this.otherSideInfo.gridApi.getSelectedRows();

    if (otherSideSelectedRows.length > 0) {
      this.otherSideInfo.activeEntry = otherSideSelectedRows[0];
    }
  }


  shiftNestingLevel(amount) {
    const newNestingLevel = Math.max(Math.min(this.newEntry.nestingLevel + amount, 4), 1);

    Promise.resolve()
      .then(() => this.newEntryService.patch(this.newEntry._id, {
        nestingLevel: newNestingLevel,
      }))
      .then(newEntry => {
        this.newEntry = newEntry;
        this.gridApi.updateRowData({update: [this.newEntry]});

        this.refreshOtherSideSelectedRow(this.newEntry);
      });

  }

}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/record-detail/record-detail.component.ts